<app-powiadomienia-filtry></app-powiadomienia-filtry>
<app-powiadomienia-tabela [tableData]="powiadomieniaRequest$ | async"></app-powiadomienia-tabela>
